<template>
  <v-container
    id="token"
    tag="section"
    fluid
  >
    <base-subheading
      class="mb-12"
      subtitle="Billit can be utilized by different types of employees for different benefits."
      title="Multi-purpose. Multi-beneficial."
    />

    <v-row
      justify="space-around"
      no-gutters class="pt-6"
    >
      <v-hover v-slot:default="{ hover }">
        <v-col
          class="text-center mb-6 mb-md-0"
          cols="12"
          md="auto"
        >
            <base-card
              class="pa-6 mb-6 mx-auto"
              color="primary" :class="hover ? 'elevation-16' : 'elevation-10'"
              width="128"
            >
              <v-icon color="white" size="74">mdi-desk</v-icon>
              <!-- <v-img
                :src="require(`@/assets/guarantees/1.png`)"
                height="74"
                width="74"
              /> -->
            </base-card>
          

          <h4 class="headline font-weight-bold">
            For Front Desk
          </h4>

          <div class="title font-weight-light">
            Find out what plan any <br> insurance card belongs to.
          </div>
        </v-col>
      </v-hover>

      <v-col cols="12" />

      <v-hover v-slot:default="{ hover }">
        <v-col
          class="text-center mb-6 mb-md-0"
          cols="12"
          md="auto"
        >
          <base-card
            class="pa-6 mx-auto mb-6"
            color="primary" :class="hover ? 'elevation-16' : 'elevation-10'"
            width="128"
          >
            <v-icon color="white" size="74">mdi-cash-plus</v-icon>
            <!-- <v-img
              :src="require(`@/assets/guarantees/2.png`)"
              height="74"
              width="74"
            /> -->
          </base-card>

          <h4 class="headline font-weight-bold">
            For Billers
          </h4>

          <div class="title font-weight-light">
            Store your practice’s billing <br> instructions for every plan.
          </div>
        </v-col>
      </v-hover>

      <v-hover v-slot:default="{ hover }">
        <v-col
          class="text-center mb-6 mb-md-0"
          cols="12"
          md="auto"
        >
          <base-card
            class="pa-6 mx-auto mb-6"
            color="primary" :class="hover ? 'elevation-16' : 'elevation-10'"
            width="128"
          >
            <v-icon color="white" size="74">mdi-desktop-classic</v-icon>
            <!-- <v-img
              :src="require(`@/assets/guarantees/3.png`)"
              height="74"
              width="74"
            /> -->
          </base-card>

          <h4 class="headline font-weight-bold">
            For Collectors
          </h4>

          <div class="title font-weight-light">
            Create a perfect follow-up <br> system for late payers.
          </div>
        </v-col>
      </v-hover>

      <!-- <v-col cols="12" />

      <v-col
        class="text-center mb-6 mb-md-0"
        cols="12"
        md="auto"
      >
        <base-card
          class="pa-6 mb-6 mx-auto"
          color="primary"
          width="128"
        >
          <v-img
            src="/assets/favicon.png"
            contain
            height="74"
            width="74"
          />
        </base-card>

        <h4 class="headline font-weight-bold">
          CRYPTO Coin
        </h4>
      </v-col>

      <v-col cols="12" />

      <v-col
        class="text-center mb-6 mb-md-0"
        cols="12"
        md="auto"
      >
        <base-card
          class="pa-6 mx-auto mb-6"
          color="primary"
          width="128"
        >
          <v-img
            :src="require(`@/assets/guarantees/4.png`)"
            height="74"
            width="74"
          />
        </base-card>

        <h4 class="headline font-weight-bold">
          Private
        </h4>

        <div class="title font-weight-light">
          128 bit Secure Chat<br>Network
        </div>
      </v-col>

      <v-col
        class="text-center mb-6 mb-md-0"
        cols="12"
        md="auto"
      >
        <base-card
          class="pa-6 mx-auto mb-6"
          color="primary"
          width="128"
        >
          <v-img
            :src="require(`@/assets/guarantees/5.png`)"
            height="74"
            width="74"
          />
        </base-card>

        <h4 class="headline font-weight-bold">
          Monitored
        </h4>

        <div class="title font-weight-light">
          99.7% Uptime Guaranteed
        </div>
      </v-col>

      <v-col cols="12" />

      <v-col
        class="text-center"
        cols="12"
        md="auto"
      >
        <base-card
          class="pa-6 mx-auto mb-6"
          color="primary"
          width="128"
        >
          <v-img
            :src="require(`@/assets/guarantees/5.png`)"
            height="74"
            width="74"
          />
        </base-card>

        <h4 class="headline font-weight-bold">
          Global
        </h4>

        <div class="title font-weight-light">
          Worldwide data centers
        </div>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Token',
  }
</script>
